import { render, staticRenderFns } from "./SectionPage.vue?vue&type=template&id=29a5f111&scoped=true&"
import script from "./SectionPage.vue?vue&type=script&lang=js&"
export * from "./SectionPage.vue?vue&type=script&lang=js&"
import style0 from "./SectionPage.vue?vue&type=style&index=0&id=29a5f111&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a5f111",
  null
  
)

export default component.exports